const compose = (...fns) => fns.reduceRight((prevFn, nextFn) => (...args) => nextFn(prevFn(...args)), value => value);

/**
 * Creates a function expression object
 * @param {{[key: string]: Function}} fnsMap
 * @param {[]} list
 * @returns {{ fns: Function[], args: []}}
 */
function createFunctionsMap(fnsMap, list) {
  const args = list.slice(list.length - 1)[0];
  const fnsNames = list.slice(0, list.length - 1);
  const fns = fnsNames.reduce((acc, fnName) => {
    return typeof fnsMap[fnName] === 'function' ? [...acc, fnsMap[fnName]] : acc;
  }, []);
  return {
    fns,
    args
  };
}

/**
 * Runs check
 * @param {{[key: string]: Function}} checkers
 * @param {[]} experession
 */
function runCheck(checkers, experession) {
  const {
    fns,
    args
  } = createFunctionsMap(checkers, experession);
  return compose(...fns)(args);
}

/**
 * Flattens object to list
 * @example
 * { a: { b: [1,2]}} -> ['a', 'b', [1,2]]
 * @param {{[key: string]: Object | []}} obj
 * @param {string[]} result
 */
const transformToList = (obj, result = []) => {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    if (Array.isArray(value)) {
      return [...acc, key, value];
    }
    return transformToList(value, [...acc, key]);
  }, result);
};

/**
 * @typedef {{[key: string]: string[] | FeatureConfig}} FeatureConfig
 */

export function getFeatures(features, locale) {
  const availableCheckers = {
    /**
     * @param {string[]} locales
     */
    allowLocales: locales => locales.includes(locale),
    not: v => !v
  };
  const mapToExpressions = featuresConfig => Object.entries(featuresConfig).reduce((acc, [key, value]) => {
    return {
      ...acc,
      [key]: transformToList(value)
    };
  }, {});
  const runChecks = expressionsMap => Object.entries(expressionsMap).reduce((acc, [key, expression]) => {
    return {
      ...acc,
      [key]: runCheck(availableCheckers, expression)
    };
  }, {});
  return runChecks(mapToExpressions(features));
}